import classNames from 'classnames'
import React from 'react'

import styles from './Operator.css'

export type OperatorProps = {
  className?: string
  'data-testid'?: string
  operator: 'AND' | 'OR'
  size: 40 | 80
}

export const Operator = ({
  className,
  'data-testid': dataTestId = 'components-elements-operator',
  operator,
  size,
}: OperatorProps) => (
  <span
    className={classNames(styles.root, styles[`size-${size}`], className)}
    data-testid={dataTestId}
  >
    {operator}
  </span>
)
